import classeNames from 'classnames';
import { Maybe } from 'graphql/jsutils/Maybe';
import React, { useMemo } from 'react';

import { IMAGE_EMPTY_PHOTO_PORTRAIT } from 'common/configuration/constants';
import { getImageUrl } from 'common/tools/network/url';
import trans from 'common/tools/translations/trans';

import styles from '../../styles.module.scss';

type CardProps = {
  director?: string | null;
  extraText?: string;
  path?: Maybe<string>;
  rating?: number;
  title?: Maybe<string>;
};

const Card = ({ director, extraText, path, rating, title }: CardProps) => {
  const imgSrc = useMemo(
    () =>
      getImageUrl({
        src: path || IMAGE_EMPTY_PHOTO_PORTRAIT,
        format: { cw: 230, ch: 306, grow: true }
      }),
    [path]
  );

  const directorLabel = useMemo(
    () => trans('rewind.metadata-director', { director }),
    [director]
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardImg}>
        <img src={imgSrc} alt={title ?? ''} />
      </div>
      {rating !== undefined && (
        <div className={styles.ratingLabel}>
          <div className={styles.rating}>{rating}</div>
        </div>
      )}
      <div className={styles.cardInformations}>
        <div
          className={classeNames(styles.cardTitle, {
            [styles.cardTitleOneLine]: !!director,
            [styles.cardTitleThreeLines]: !director
          })}
          // As the text could be cut off by ellipses,
          // we add a text overlay to help read the full title.
          {...(title ? { title } : {})}
        >
          {title}
        </div>
        {director && (
          <div className={styles.cardDirector} title={directorLabel}>
            {directorLabel}
          </div>
        )}
        {extraText && <div className={styles.cardExtraText}>{extraText}</div>}
      </div>
    </div>
  );
};
export default Card;
